import { render, staticRenderFns } from "./videoMarking.vue?vue&type=template&id=036ba75a&scoped=true&"
import script from "./videoMarking.vue?vue&type=script&lang=js&"
export * from "./videoMarking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ba75a",
  null
  
)

export default component.exports